import { createLucideIcon } from 'lucide-react';

// The pause icon from the Recording Indicator design, scaled from its 16px grid to lucide's 24.
// Not lucide's `Pause`, whose bars are narrower: https://www.figma.com/design/3D1M41vrCJZnkNBEmWopxx/Design---Unmod---Participant?node-id=8689-26876
export const PauseSolid = createLucideIcon('PauseSolid', [
  ['rect', { key: 'rect-1', x: '5', y: '3', width: '6', height: '18', rx: '1', fill: 'currentColor', stroke: 'none' }],
  ['rect', { key: 'rect-2', x: '13', y: '3', width: '6', height: '18', rx: '1', fill: 'currentColor', stroke: 'none' }],
]);
